import { render } from "./CommonPagination.vue?vue&type=template&id=526d1de0&scoped=true"
import script from "./CommonPagination.vue?vue&type=script&lang=js"
export * from "./CommonPagination.vue?vue&type=script&lang=js"

import "./CommonPagination.vue?vue&type=style&index=0&id=526d1de0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526d1de0"]])

export default __exports__